<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-textarea
                    v-model="complaint.correctiveMeasures"
                    label="Środki korygujące niezgodność"
                    :disabled="!canSaveComplaint || isComplaintIneditable"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

export default {
    name: 'Commissions',
    props: {
        complaint: {
            type: Object,
            default: null
        },
        validations: {
            type: Object,
            default: null
        },
        canSaveComplaint: {
            type: Boolean
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.userId
        },
        isDraftComplaint() {
            return this.complaint.complaintStatusId === 15
        },
        isComplaintIneditable() {
            return this.isDraftComplaint && (this.complaint.creator.id != this.userId)
        },
    }
}
</script>